// Top-level router (= DDSIM-21)。 menu → practice setup → 試合 → 終局 の入口。

import { BrowserRouter, Route, Routes } from "react-router-dom";

import { Match } from "./routes/Match";
import { Menu } from "./routes/Menu";
import { Practice } from "./routes/Practice";

function NotFound(): JSX.Element {
  return <main className="p-8">404</main>;
}

export function App(): JSX.Element {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Menu />} />
        <Route path="/practice" element={<Practice />} />
        <Route path="/match" element={<Match />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
